import { SubscriptionApp } from '@focuslee/shared';
import { SubscriptionPage, type PremiumUser } from '@focuslee/shared-mini-app';
import { useCallback } from 'react';
import { loginData } from '../client/apollo';
import { UserRole } from '../client/generated/graphql';
import { FocusLeePlaceholderImage } from '../components/common/FocusLeePlaceholderImage';
import { useAnalytics } from '../hooks/useAnalytics';

export function PremiumPage() {
    const { recordEvent } = useAnalytics();
    const syncEntitlement = useCallback((user: PremiumUser) => {
        const session = loginData();
        if (session && session.role !== user.role) loginData({ ...session, role: user.role as UserRole });
    }, []);
    return (
        <SubscriptionPage
            app={SubscriptionApp.focuslee}
            artwork={<FocusLeePlaceholderImage kind="premium" size={160} />}
            recordEvent={recordEvent}
            onEntitlementChanged={syncEntitlement}
        />
    );
}
